import React from "react";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/react-hooks";
import { deleteSourceFromDeploymentMutation } from "../mutation";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { ActionWithModal } from "components/buttons";

const RemoveSourceButton = ({ show, item, intl }) => {
  const history = useHistory();

  const { currentCustomerId } = useCurrentCustomerContext();
  const [deleteSourceFromDeployment] = useMutation(deleteSourceFromDeploymentMutation);

  const title = intl.formatMessage({ id: "app.page.deployment.details.deleteSource.title" });
  const element = item.description
    ? item.description
    : intl.formatMessage({ id: "app.dialog.delete.elementToDelete.default" });
  const descriptionText = intl.formatMessage(
    { id: "app.page.deployment.details.deleteSource.text" },
    { element: element },
  );

  const handleSuccess = () => {
    history.push(0);
  };

  return show ? (
    <ActionWithModal
      showLoading
      mutation={deleteSourceFromDeployment}
      mutationVariables={{
        sourceId: item.id,
        deploymentId: item.deploymentId,
        customerId: currentCustomerId,
      }}
      elementNameInResult="deleteSourceFromDeployment"
      elementToDelete={item.codename}
      dialogTitle={title}
      renderDialogContent={() => descriptionText}
      onSuccess={handleSuccess}
      icon="remove-circle"
    />
  ) : null;
};

RemoveSourceButton.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   ** Indica si se muestra
   **/
  show: PropTypes.bool,
};

export default injectIntl(RemoveSourceButton);
